import * as React from 'react';
import {
    Create,
    ReferenceInput,
    TextInput,
    SimpleForm,
    required,
    SelectInput,
    NumberInput,
    AutocompleteInput,
    useDataProvider,
    DataProviderContext,
} from 'react-admin';
import FileUpload from '../../common/inputs/FileUpload';
import { LoadingSection } from '../../common/LoadingSection';

import { useParams } from 'react-router';
import HTMLEditorInput, { validHtml } from '../../common/inputs/HTMLEditorInput';
import SlugInput from '../../common/inputs/SlugInput';
import { createCustomGoDataProvider } from '../../services';

const SubjectCreate = () => {
    let { programId } = useParams();
    const baseDataProvider = useDataProvider();
    if (!programId) {
        return <LoadingSection />;
    }
    const customDataProvider = React.useMemo(
        () =>
            createCustomGoDataProvider(baseDataProvider, [
                { resource: 'subjects', apiEndpoint: `/subjects` },
            ]),
        [baseDataProvider],
    );
    return (
        <DataProviderContext.Provider value={customDataProvider}>
            <Create
                redirect={(e: any, id: any) => {
                    return `programs/${programId}/subjects`;
                }}
                resource={'subjects'}
            >
                <SimpleForm defaultValues={{ programId: programId }}>
                    <FileUpload type="VIDEO_THUMBNAIL" source="image" />
                    <TextInput source="name" fullWidth validate={[required()]} />
                    <SlugInput source="slug" fullWidth />
                    <NumberInput source="displayOrder" fullWidth />
                    <HTMLEditorInput
                        source={'description'}
                        fullWidth
                        validate={[required(), validHtml]}
                    />
                </SimpleForm>
            </Create>
        </DataProviderContext.Provider>
    );
};

export default SubjectCreate;
